import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { withTranslation, useTranslation } from 'react-i18next';

// Utils
import { urlPublicS3 } from '../../helpers';

const QuotationImagesList = ({ quotation, title, status}) => {
  const { t } = useTranslation('formInApproval');
  const [imagesArray] = useState(quotation ? JSON.parse(quotation) : []);
  
  return (
    <Col className={`${status} ${ status == 4 ? 'col-collapse' : ''}`} xs={12} sm={12} md={status == 4 ? 3 : 6}>
      <label className="col-form-label second title-2" >{title}</label>
      <div className='list_items_file'>
        {imagesArray && imagesArray.length > 0 ? (
          <ul>
            {imagesArray.map((image, index) => (
              <li key={index}>
                <a  className="a-vehicle" href={`${urlPublicS3()}/${image.download_link}`} target="_blank"  rel="noreferrer">
                {t('view_image')} {index + 1}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p>{t('not_image')}</p>
        )}
      </div>
    </Col>
  );
};

// Definir los tipos de prop para asegurar que `quotation` sea un objeto con la propiedad `images` que sea un array
QuotationImagesList.propTypes = {
  quotation: PropTypes.string,
  title: PropTypes.string,
  status: PropTypes.number,
};
QuotationImagesList.defaultProps = {
  quotation: null,
};

export default withTranslation(['formInApproval'])(QuotationImagesList);
